import { Seo } from "@/components/Seo";
import { Hero } from "@/components/home/Hero";
import { Categories } from "@/components/home/Categories";
import { FleetPreview } from "@/components/home/FleetPreview";
import { About } from "@/components/home/About";
import { Services } from "@/components/home/Services";
import { CtaBand } from "@/components/layout/CtaBand";
import { Marquee } from "@/components/motion/Marquee";

const BRANDS = [
  { name: "Wacker Neuson", src: "/images/brands/wacker-neuson.png", h: 40 },
  { name: "Genie", src: "/images/brands/genie-white.png" },
  { name: "JCB", src: "/images/brands/jcb.svg", h: 26 },
  { name: "Oil&Steel" },
  { name: "Gehl", src: "/images/brands/gehl.svg" },
  { name: "Iveco", src: "/images/brands/iveco.svg" },
  { name: "Isuzu", src: "/images/brands/isuzu.svg" },
];

export default function Home() {
  return (
    <>
      <Seo description="Desp sas (DESP di Sandro Pace): noleggio piattaforme aeree, escavatori Wacker Neuson, dumper e minipale a Catania. Consegna in cantiere in tutta la Sicilia orientale. Dove serve, quando serve." path="/" />
      <Hero />
      <Marquee items={BRANDS} />
      <Categories />
      <FleetPreview />
      <About />
      <Services />
      <CtaBand />
    </>
  );
}
